import request from './request'
export function generatePrompt(data) {
    const params = new URLSearchParams();
    params.append('jobDescriptionContent', data.jobDescriptionContent);
    params.append('resumeContent', data.resumeContent);
    
    return request({
      url: `/api/newAIGC/generate_prompt?${params.toString()}`,
      method: 'post',
    })
  }

